import React from 'react';

import { Container } from 'common/components/Layout/Layout';

import Image from 'common/components/Placeholder/components/Image/Image';
import TextBlock from 'common/components/Placeholder/components/TextBlock/TextBlock';

import styles from './FullWidthBackground.module.scss';

const FullWidthBackground = () => (
  <div className={styles.FullWidthBackground}>
    <Container className={styles.PlaceholderContainer}>
      <Image 
        color={styles.PlaceholderDefaultColor} 
        className={styles.ImageBig} />
      <TextBlock
        rows={9}
        color={styles.PlaceholderDefaultColor}
        className={styles.TextBlock}
      />
    </Container>
  </div>
);

export default FullWidthBackground;



// WEBPACK FOOTER //
// ./src/common/components/Placeholder/components/FullWidthBackground/FullWidthBackground.js